<template>
  <CustomBtnToggle
    :value="vehicleCategoryId"
    data-test="comfortSelection"
    :items="comfortTypeItems"
    @change="setComfortType"
  />
</template>
<script lang="ts">
export default {
  name: 'SComfortSelection',
};
</script>

<script setup lang="ts">
import CustomBtnToggle from '@slg/web-customer-shared/src/components/common/CustomBtnToggle.vue';

defineProps({
  vehicleCategoryId: {
    type: String,
    default: null,
  },
  comfortTypeItems: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['setComfortType']);

function setComfortType(newValue) {
  emit('setComfortType', newValue);
}
</script>
